import FieldPriority from "../../../generic/priority/priority"
import FieldConfig from "../../../proto/field-config"
import Project from "../../../../model2/project/project"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"

export default class FieldProjectPriority extends FieldPriority {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project priority";
        this.label      = _.get(config, 'label', "Project priority")


        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangePriority
    }

    tableCellOnValueChange = (item: ItemModelV2, value:any, manager:TasksViewManager) => {

        item.project.priority = value
        item.project.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        // FieldProto_updateView(manager as TasksViewManager, this)
        // manager.update([
        //     LifecycleAction.GROUP,
        //     LifecycleAction.PROCESS_DATA,
        //     LifecycleAction.RENDER
        // ])

    }


}